import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=054d91d0&scoped=true"
import script from "./HomeFooter.vue?vue&type=script&lang=js"
export * from "./HomeFooter.vue?vue&type=script&lang=js"
import style0 from "./HomeFooter.vue?vue&type=style&index=0&id=054d91d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054d91d0",
  null
  
)

export default component.exports